import noop from 'lodash/noop';

const POLLS_WEBVIEW_API = 'tcspolls://action/';
export const WEBVIEW_ACTION_TIMEOUT = 500;
export const WEBVIEW_CLOSE_ACTION_TIMEOUT = 1000;

export interface WebviewActionRequestParams {
  method: string;
  query?: string;
}

/**
 * Вызов deeplink в обход машины возможен только в исключительных случаях.
 * Вызов deeplink напрямую может привести к потери событий, поэтому в большинстве случаев нужно использовать событие invokeDeeplink машины.
 */
export const invokeWebviewDeeplink = async (
  by: 'heuristic' | 'location',
  ...payloads: WebviewActionRequestParams[]
): Promise<unknown> => {
  switch (by) {
    case 'heuristic':
      await invokeWebviewActionViaHeuristic(...payloads);
      return;
    case 'location':
      await Promise.all(payloads.map(invokeWebviewActionViaLocation));
      return;
    default:
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-case-declarations
      const _: never = by;
      return;
  }
};

/**
 * Работает на Android и на iOS
 *
 * Если платформа или родительское приложение не поддерживает action, то на Android показывает экран ошибки. На iOS выкидывает exception
 */
const invokeWebviewActionViaLocation = (payload: WebviewActionRequestParams) => {
  window.location.replace(webActionUrl(payload));
  return Promise.resolve();
};

/**
 * Работает на Android
 *
 * Если платформа или родительское приложение не поддерживает action, то ничего не делает
 */
const invokeWebviewActionViaIframe = (payload: WebviewActionRequestParams) => {
  return new Promise<void>((resolve, reject) => {
    try {
      const iframe = document.createElement('iframe');
      iframe.setAttribute('style', 'opacity: 0');
      iframe.width = '1';
      iframe.height = '1';
      document.body.appendChild(iframe);
      iframe.src = webActionUrl(payload);
      resolve();
    } catch (e) {
      reject(e);
    }
  });
};

/** Пытается вызвать первый поддерживаемый action выхода.
 *
 * Сперва пытается вызвать action через iframe (для работы на Android).
 *
 * Затем через location (для работы на iOS) */
const invokeWebviewActionViaHeuristic = async (...payloads: WebviewActionRequestParams[]) => {
  for (const payload of payloads) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.trace(`invokeWebviewActionViaIframe: ${webActionUrl(payload)}`);
    }

    invokeWebviewActionViaIframe(payload).catch(noop);
    await new Promise(r => setTimeout(r, WEBVIEW_ACTION_TIMEOUT));
  }

  for (const payload of payloads) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.trace(`invokeWebviewActionViaLocation: ${webActionUrl(payload)}`);
    }
    invokeWebviewActionViaLocation(payload).catch(noop);
    await new Promise(r => setTimeout(r, WEBVIEW_ACTION_TIMEOUT));
  }
};

export function webActionUrl(payload: WebviewActionRequestParams) {
  const { method, query } = payload;
  // @ts-expect-error window.POLLS_WEBVIEW_API_MOCK_URL does not exist
  return `${window.POLLS_WEBVIEW_API_MOCK_URL ?? POLLS_WEBVIEW_API}${method}${query ? `${query}` : ''}`;
}
